import { useDebouncedFunc } from '@cgn/framework-ui-components/hooks';
import { useMemo, useState } from 'react';

export default function useDeferredChangeOggettoMessaggio(onChangeOggetto, onChangeMessaggio) {
  const [defStato, setDefStato] = useState({});
  const setStatoListaContenutiSimiliDebounced = useDebouncedFunc(setDefStato, 300);

  const [handleChangeMessaggio, handleChangeOggetto] = useMemo(() => {
    const handleMessaggio = (value) => {
      onChangeMessaggio(value);
      setStatoListaContenutiSimiliDebounced((s) => ({ ...s, messaggio: value }));
    };
    const handleOggetto = (value) => {
      onChangeOggetto(value);
      setStatoListaContenutiSimiliDebounced((s) => ({ ...s, oggetto: value }));
    };
    return [handleMessaggio, handleOggetto];
  }, [onChangeMessaggio, onChangeOggetto, setStatoListaContenutiSimiliDebounced]);

  return [defStato.oggetto, handleChangeOggetto, defStato.messaggio, handleChangeMessaggio];
}
